module.exports = __webpack_public_path__ + "static/img/025家居合集.840099c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/025家居合集.jpg
// module id = bfTV
// module chunks = 0